import * as React from 'react';
import {
  IComparisonPlan,
  ICustomerType,
  PlanComparisonCard,
  RatesAccordionContextProvider,
} from '@origin-digital/plans';
import { Horizontal } from '@origin-digital/layout';
import './plans-container.scss';
import { ConnectionAddressObject } from '@origin-digital/address-lookup';
import { getContentSourceTitle } from '../compare-plans-utils';

interface IPlansContainer {
  plans: IComparisonPlan[];
  planSelectCallback: (plan: IComparisonPlan) => void;
  renewableEnergy: {
    electricity: number;
    gas: number;
  };
  customerType: ICustomerType;
  toolTipContent: string;
  region: string;
  postcode: string;
  isBusiness: boolean;
  address?: ConnectionAddressObject;
}

export default class PlansContainer extends React.Component<IPlansContainer> {
  constructor(props: IPlansContainer) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.addressUpdate) {
      return false;
    } else {
      return true;
    }
  }

  _scrollToFilter = () => document.getElementById('cp-filter-container').scrollIntoView();

  render() {
    const {
      plans,
      address,
      planSelectCallback,
      renewableEnergy,
      customerType,
      toolTipContent,
      postcode,
      region,
      isBusiness,
    } = this.props;

    return (
      <Horizontal collapse>
        <RatesAccordionContextProvider addressLinkClickHandler={this._scrollToFilter}>
          {plans.map((plan, index) => {
            return (
              <PlanComparisonCard
                bannerContent={null}
                contentSourceTitle={getContentSourceTitle(plan.title)}
                plan={plan}
                address={address}
                planSelectCallback={planSelectCallback}
                renewableEnergy={renewableEnergy}
                customerType={customerType}
                toolTipContent={toolTipContent}
                hideToolTip={false}
                links={plan.links}
                postcode={postcode}
                region={region}
                hideBonusOffer={isBusiness}
                showPostcode={!address}
              />
            );
          })}
        </RatesAccordionContextProvider>
      </Horizontal>
    );
  }
}
